import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "019a03f9-888f-431f-b1d0-3ed799a77d19", content: "L ≈ 50 dB SPL", options: {} },
  { id: "b166c44e-ab1e-4788-8de8-21ab6c37d4f3", content: "L ≈ 80 dB SPL", options: {} },
  { id: "5e425c0a-8a81-48fa-ad60-556fec19ca56", content: "N = 4 sones", options: {} },
  { id: "ccb3d732-7c38-4b4f-b614-b7755a569a4c", content: "L<sub>N</sub> = 100 phons", options: {} },
  { id: "3e601bf9-01f9-474e-a19a-a51d44b24667", content: "L<sub>N</sub> = 60 phons", options: {} },
  { id: "e244f8c8-3d2e-46bb-85a2-1cb41cd69d1b", content: "N = 5 sones", options: {} },
];

export const task: Task = {
  id: "8596eebd-2b30-4f0c-9f5e-ce94dad2ee9b",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["019a03f9-888f-431f-b1d0-3ed799a77d19", "5e425c0a-8a81-48fa-ad60-556fec19ca56"],
};
